<template>
  <div>
    <v-row class="desposite-dashboadpage investomerter-dashboad-page">
      <v-col xs="8" md="8">
        <div class="head-text investomerter-heading">
          <h1>Investometer (Your Personal Finance Wellness Score)</h1>
        </div>
      </v-col>
      <v-col xs="4" md="4" class="investomerter_select-userbox">
        <div class="right-sidetop-box">
          <div class="select-box">
            <v-card>
              <v-select :items="member_items" :v-model="member_name" item-value="id" item-text="name" :value="member_name"
                chips label="All Users" @change="refreshDashboard($event)"></v-select>

            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="investomerter-dashboad" v-if="hasApiResponse">
      <v-col xs="12" md="12">
        <div class="total-investment-box">

          <div class="total-investment">
            <div class="total-amountbox">
              <div class="amount">
                <p>Total Investments</p>
                <h3><span>&#8377</span>{{ formatPrice(investmentTotal) }}</h3>
              </div>
              <div class="icon">
                <v-img max-height="50" max-width="50" :src="require('@/assets/images/dollor-icon.png')">
                </v-img>
              </div>
            </div>
            <ul class="amount-detail_list">
              <li v-for="(item, index) in investmentsData" :key="index">
                <div class="dot" v-bind:style="{ background: item.web_color }"></div>
                <div class="content">
                  <a @click="redirectDashboard(item.name)">{{ item.name }}</a>
                  <h5><span>&#8377</span>{{ formatPrice(item.amount) }}</h5>
                </div>
              </li>
            </ul>
          </div>
          <div class="total-liabilities">
            <div class="total-amountbox">
              <div class="amount">
                <p>Total Liabilities</p>
                <h3><span>&#8377</span>{{ formatPrice(liabilityTotal) }}</h3>
              </div>
              <div class="icon">
                <v-img max-height="50" max-width="50" :src="require('@/assets/images/dollor2-icon.png')">
                </v-img>
              </div>
            </div>
            <ul class="amount-detail_list">
              <li v-for="(item, i) in liabilityData" :key="i">
                <div class="dot" v-bind:style="{ background: item.web_color }"></div>
                <div class="content">
                  <a @click="redirectLiabilityDashboard(item.name)">{{ item.name }}</a>
                  <h5><span>&#8377</span>{{ formatPrice(item.amount) }}</h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </v-col>
      <v-col xs="12" md="12">
        <div class="mix-box">
          <div class="investment-mix">
            <h3>Your Investment Mix</h3>
            <div class="list-detail">
              <ul>
                <li>
                  <div class="dot" style="background-color:#8332a8"></div>
                  <p>Sukanya Samriddhi</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#A1A8FF"></div>
                  <p>Bullions</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#FFC241"></div>
                  <p>Commodities</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#27CEEF"></div>
                  <p>Mutual Funds</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#1C5CC2"></div>
                  <p>Real Estate</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#32a84e"></div>
                  <p>Life Insurance</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#0F487F"></div>
                  <p>Equities & Bonds</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#50ABF2"></div>
                  <p>Savings Accounts</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#90BAFF"></div>
                  <p>Fixed Deposits</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#6C3D10"></div>
                  <p>Private Investment</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#3B55B5"></div>
                  <p>Recurring Deposits</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#967641"></div>
                  <p>Retirement</p>
                </li>
              </ul>
              <div class="detail-chart">
                <apexchart type="pie" :options="chartOptions" :series="series" investmentGraphData height="100%"
                  width="100%"></apexchart>
              </div>
            </div>
          </div>
          <div class="liabilities-mix">
            <h3>Your Liabilities Mix</h3>
            <div class="list-detail">
              <ul>
                <li>
                  <div class="dot" style="background-color:#F19100"></div>
                  <p>Home Loan</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#50ABF2"></div>
                  <p>Policy Loan</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#967641"></div>
                  <p>Consumer Loan</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#9B633D"></div>
                  <p>Student Loan</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#A1A8FF"></div>
                  <p>Two Wheeler Loan</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#C66E29"></div>
                  <p>Car Loan</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#27CEEF"></div>
                  <p>Loan Against Property</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#DF6D20"></div>
                  <p>Personal Loan</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#a83285"></div>
                  <p>Overdraft</p>
                </li>
                <li>
                  <div class="dot" style="background-color:#8332a8"></div>
                  <p>Credit Card</p>
                </li>
              </ul>
              <div class="detail-chart">
                <apexchart type="pie" :options="liabilityChartOptions" :series="liabilitySeries" investmentGraphData
                height="100%" width="100%"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <span style="padding-left: 15px;display: block;">Note: For Insurance only Surrender value or Fund value is
          considered.</span>
      </v-col>
      <v-col xs="12" md="12">
        <div class="insurance-policy-box">
          <div class="top-head">
            <h4>Your life Insurance Policy Payout ({{ currentDate }})</h4>
          </div>
          <div class="Policy-list">
            <ul>
              <li v-for="(item, index) in insuranceData" :key="index">
                <div class="date-box">
                  <p>{{ item.name }} ({{ item.policy_number }})</p>
                  <h5>{{ item.date }}</h5>
                </div>
                <div class="amount-box">
                  <p>{{ item.label }}</p>
                  <h4><span>&#8377</span>{{ formatPrice(item.amount) }}</h4>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </v-col>

      <v-col xs="12" md="12" class="bottom-cardbox">
        <div class="investomerter-bottom-cardbox">
          <ul>
            <li>
              <h6>My Networth</h6>
              <div class="card-detail">
                <div class="content">
                  <h4><span>&#8377</span>{{ formatPrice(this.investometerGraphData[0]['networth_amount']) }}</h4>
                  <p>Your investment as on {{ this.investometerGraphData[3]['curr_date'] }} is
                    {{ this.investometerGraphData[0]['networth_percentage'] }}% of your liabilities.</p>
                </div>
                <div>
                  <vue-speedometer :width="150" :minValue="0" :maxValue="200" :needleHeightRatio="0.3"
                    :maxSegmentLabels="4"
                    :customSegmentLabels='[{ text: "75%", position: "OUTSIDE", color: "red" }, { text: "100%", position: "OUTSIDE", color: "yellow" }, { text: "125%", position: "OUTSIDE", color: "lightgreen" }, { text: "", position: "OUTSIDE", color: "darkgreen" }]'
                    :value="this.spike_val1" :segments="4" :segmentColors='["red", "yellow", "lightgreen", "darkgreen"]'
                    :ringWidth="30" :needleTransitionDuration="3333" needleTransition="easeElastic" />
                </div>
              </div>
            </li>
            <li>
              <h6>My Contingent Networth</h6>
              <div class="card-detail">
                <div class="content">
                  <h4><span>&#8377</span>{{ formatPrice(this.investometerGraphData[1]['networth_amount']) }}</h4>
                  <p>Your contingent networth is {{ this.investometerGraphData[1]['networth_percentage'] }}% of you
                    liabilities Your contingent networth includes sum assured from your life insurance policies.</p>
                </div>
                <div>
                  <vue-speedometer :width="150" :minValue="0" :maxValue="200"
                    :customSegmentLabels='[{ text: "75%", position: "OUTSIDE", color: "red" }, { text: "100%", position: "OUTSIDE", color: "yellow" }, { text: "150%", position: "OUTSIDE", color: "lightgreen" }, { text: "", position: "OUTSIDE", color: "darkgreen" }]'
                    :value="this.spike_val2" :needleHeightRatio="0.3" :maxSegmentLabels="4" :segments="4"
                    :segmentColors='["red", "yellow", "lightgreen", "darkgreen"]' :ringWidth="30"
                    :needleTransitionDuration="3333" needleTransition="easeElastic" />
                </div>
              </div>
            </li>
            <li>
              <h6>My Interest Ratio</h6>
              <div class="card-detail">
                <div class="content">
                  <h4>{{ this.investometerGraphData[2]['networth_percentage'] }}%</h4>
                  <p>Your total loan EMIs payable in a year is {{ this.investometerGraphData[2]['networth_percentage'] }}%
                    of your investment.</p>
                </div>
                <div>
                  <vue-speedometer :width="150" :needleHeightRatio="0.3" :maxSegmentLabels="4" :minValue="0"
                    :maxValue="160" :value="this.spike_val3" :segments="4"
                    :customSegmentLabels='[{ text: "10%", position: "OUTSIDE", color: "darkgreen" }, { text: "20%", position: "OUTSIDE", color: "lightgreen" }, { text: "30%", position: "OUTSIDE", color: "yellow" }, { text: "", position: "OUTSIDE", color: "red" }]'
                    :segmentColors='["darkgreen", "lightgreen", "yellow", "red"]' :ringWidth="30"
                    :needleTransitionDuration="3333" needleTransition="easeElastic" />
                </div>
              </div>
            </li>
            <li>
              <h6>My Liquid Investment Ratio</h6>
              <div class="card-detail">
                <div class="content">
                  <h4>{{ this.investometerGraphData[3]['networth_percentage'] }}%</h4>
                  <p>Your liquid assets as on {{ this.investometerGraphData[3]['curr_date'] }} is
                    {{ this.investometerGraphData[3]['networth_percentage'] }}% of your total investment.</p>
                </div>
                <div>
                  <vue-speedometer :width="150" :needleHeightRatio="0.3" :maxSegmentLabels="4" :minValue="0"
                    :maxValue="160" :value="this.spike_val4" :segments="4"
                    :customSegmentLabels='[{ text: "10%", position: "OUTSIDE", color: "darkgreen" }, { text: "25%", position: "OUTSIDE", color: "lightgreen" }, { text: "50%", position: "OUTSIDE", color: "yellow" }, { text: "", position: "OUTSIDE", color: "red" }]'
                    :segmentColors='["darkgreen", "lightgreen", "yellow", "red"]' :ringWidth="30"
                    :needleTransitionDuration="3333" needleTransition="easeElastic" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>
      <div class="investometer-buttonbox">
        <v-btn class="btn download-btn" @click="downloadReport">
          <v-img max-height="20" max-width="16" :src="require('@/assets/images/download-icon.png')"></v-img>
          Download Your Investometer
        </v-btn>
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="btn download-btn share-btn" v-bind="attrs" v-on="on">
              <v-img max-height="20" max-width="16" :src="require('@/assets/images/share-icon.png')"></v-img>
              Share Your Investometer
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title>
                <WhatsApp :url="share_report_url" scale="1.6"></WhatsApp>
              </v-list-item-title>
              <v-list-item-title>
                <Telegram :url="share_report_url" scale="1.6"></Telegram>
              </v-list-item-title>
              <v-list-item-title>
                <Email :url="share_report_url" scale="1.6"></Email>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-col xs="12" md="12" class="bottom-cardbox">
        <div class="investomerter-bottom-cardbox">
          <ul>
            <li class="riskometer_li" v-for="(riskoMeterItems, index) in riskoMeterList" :key="riskoMeterItems.id">

              <div class="riskometerUpdate">
                <v-img max-width="130" :src="riskometeLogo" :lazy-src="riskometeLogo"> </v-img>
                <div class="income_date d-flex">
                  <p>Update/modify</p>
                  <a @click="moveToRikometer(riskoMeterItems.member_id)"><v-img max-height="22" max-width="20"
                      :src="syncIcon"></v-img></a>
                </div>
              </div>

              <div class="card-detail">
                <div class="content">
                  <h4>{{ riskoMeterItems.username }}</h4>
                  <div class="info_box date-and-info">
                    <h3>{{ riskoMeterItems.last_modifed_date }}</h3>
                  </div>
                  <p><br>Your risk tolerance Score is <b style="color:#1A407D">{{ riskoMeterItems.score }}</b>.
                    {{ riskoMeterItems.txt }}.</p>
                </div>
                <div>
                  <vue-speedometer :width="150" :minValue="0" :needleHeightRatio="0.3" :maxSegmentLabels="4"
                    :customSegmentLabels='[{ text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", fontSize: "19px", }, { text: "", color: "#555", }, { text: "", position: "INSIDE", color: "#555", },]'
                    :segmentColors='["darkgreen", "lightgreen", "#f6c71e", "#f6961e", "red"]'
                    :value="(index == 0) ? riskoMeterSpikeVal1 : (index == 1) ? riskoMeterSpikeVal2 : (index == 2) ? riskoMeterSpikeVal3 : (index == 4) ? riskoMeterSpikeVal5 : (index == 5) ? riskoMeterSpikeVal6 : riskoMeterSpikeVal7"
                    :currentValueText="riskoMeterItems.riskometer.toString()" currentValueColor="black" :segments="5"
                    :ringWidth="30" :needleTransitionDuration="3333" needleTransition="easeElastic" needleColor="#05275e"
                    textColor="#555" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>

      <v-col xs="12" md="12" class="bottom-cardbox">
        <div class="investomerter-bottom-cardbox">
          <ul>
            <li style="width:100%" v-for="(singleProtectoMeterDetail, index) in protectoMeterDetail"
              :key="singleProtectoMeterDetail.id">
              <div class="name-with-logo"><v-img max-width="160" :src="protectometerLogo" :lazy-src="protectometerLogo">
                </v-img>
                <h4>{{ singleProtectoMeterDetail.username }}</h4>
              </div>
              <div class="row">
                <div class="income_container">
                  <div class="sync_detils"></div>
                  <section class="your_income_section">
                    <div class="col-md-6">
                      <div class="info_box date-and-info">
                        <div class="income_title">
                          <h3>{{ singleProtectoMeterDetail.last_modifed_date }}</h3>
                        </div>
                        <div class="income_date d-flex">
                          <p>Update/modify</p>
                          <a @click="updateProtectometer(singleProtectoMeterDetail.member_id)"><v-img max-height="22"
                              max-width="20" :src="syncIcon"></v-img></a>
                        </div>
                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon">
                          <div>
                            <p>Current Life Insurance Cover</p>
                          </div>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleProtectoMeterDetail.LifeInsuranceCover)" readonly />
                        </div>

                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon">
                          <div>
                            <p>Additional Life Insurance Needed&nbsp;&nbsp;&nbsp;</p>
                          </div>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleProtectoMeterDetail.lifeInsuranceNeed)" readonly />
                        </div>
                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon d-block">
                          <div class="d-flex">
                            <div>
                              <p class="mb-1">Your Life Insurance Score <br><span
                                  class="percent-num">({{ singleProtectoMeterDetail.lifeInsuranceScore }}%)</span></p>
                            </div>
                          </div>
                          <div><span></span></div>
                        </div>
                        <div class="fields">
                          <vue-speedometer :width="150" :height="100" :minValue="0" :needleHeightRatio="0.3"
                            :maxSegmentLabels="4"
                            :customSegmentLabels='[{ text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", fontSize: "19px", }, { text: "", color: "#555", }, { text: "", position: "INSIDE", color: "#555", },]'
                            :segmentColors='["red", "#f6c71e", "lightgreen", "darkgreen"]'
                            :value="(index == 0) ? protectoLifeMeterSpikeVal1 : (index == 1) ? protectoLifeMeterSpikeVal2 : (index == 2) ? protectoLifeMeterSpikeVal3 : (index == 4) ? protectoLifeMeterSpikeVal5 : (index == 5) ? protectoLifeMeterSpikeVal6 : protectoLifeMeterSpikeVal7"
                            :currentValueText="singleProtectoMeterDetail.lifeInsururanceScoreText.toString()"
                            currentValueColor="black" :segments="4" :ringWidth="15" :needleTransitionDuration="3333"
                            needleTransition="easeElastic" needleColor="#05275e" textColor="#555" valueTextFontSize="9"/>
                        </div>
                      </div>
                      <div class="terms-box">
                        <p>Increase your life insurance cover by Rs
                          {{ formatPrice(singleProtectoMeterDetail.lifeInsuranceNeed) }}.</p>
                        <span>Click <b><a @click="checkTerm()">TERM</a></b> to check the best Term Insurance
                          Premiums</span>
                      </div>
                    </div>
                    <div class="col-md-6 investments">
                      <div class="info_box date-and-info">
                        <div class="income_title">
                          <h3>{{ singleProtectoMeterDetail.last_modifed_date }}</h3>
                        </div>
                        <div class="income_date d-flex">
                          <p>Update/modify</p>
                          <a @click="updateProtectometer(singleProtectoMeterDetail.member_id)"><v-img max-height="22"
                              max-width="20" :src="syncIcon"></v-img></a>
                        </div>
                      </div>
                      <div class="your_ins_price">
                        <div class="text">
                          <p>Current Health Insurance Cover</p>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleProtectoMeterDetail.HealthInsuranceCover)" readonly />
                        </div>
                      </div>
                      <div class="your_ins_price">
                        <div class="text">
                          <p>Additional Health Insurance Needed</p>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleProtectoMeterDetail.healthInsuranceNeed)" readonly />
                        </div>
                      </div>
                      <div class="your_ins_price">
                        <div class="text">
                          <p>
                            Your Health Insurance Score <br><span
                              class="percent-num">({{ singleProtectoMeterDetail.healthInsuranceScore }}%)</span>
                          </p>
                          <span></span>
                        </div>
                        <div class="fields">
                          <vue-speedometer :width="150" :height="100" :minValue="0" :needleHeightRatio="0.3"
                            :maxSegmentLabels="4"
                            :customSegmentLabels='[{ text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", fontSize: "19px", }, { text: "", color: "#555", }, { text: "", position: "INSIDE", color: "#555", },]'
                            :segmentColors='["red", "#f6c71e", "lightgreen", "darkgreen"]'
                            :value="(index == 0) ? protectoHealthMeterSpikeVal1 : (index == 1) ? protectoHealthMeterSpikeVal2 : (index == 2) ? protectoHealthMeterSpikeVal3 : (index == 4) ? protectoHealthMeterSpikeVal5 : (index == 5) ? protectoHealthMeterSpikeVal6 : protectoHealthMeterSpikeVal7"
                            :currentValueText="singleProtectoMeterDetail.healthInsururanceScoreText.toString()"
                            currentValueColor="black" :segments="4" :ringWidth="15" :needleTransitionDuration="3333"
                            needleTransition="easeElastic" needleColor="#05275e" textColor="#555" valueTextFontSize="9"/>
                        </div>
                      </div>
                      <div class="terms-box">
                        <p>Increase your health insurance cover by Rs
                          {{ formatPrice(singleProtectoMeterDetail.healthInsuranceNeed) }}.</p>
                        <span>Click <b><a @click="checkTerm()">HEALTH</a></b> to check the best Health Insurance
                          Premiums</span>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>


      <!-- <p>--------------------------------------Retirometer-------------------</p>-->
      <v-col xs="12" md="12" class="bottom-cardbox">
        <div class="investomerter-bottom-cardbox">
          <ul>
            <li style="width:100%" v-for="(singleRetiroMeterDetail, index) in retiroMeterDetail"
              :key="singleRetiroMeterDetail.id">
              <div class="name-with-logo"><v-img max-width="160" :src="retirometerLogo" :lazy-src="retirometerLogo">
                </v-img>
                <h4>{{ singleRetiroMeterDetail.username }}</h4>
              </div>
              <div class="row">
                <div class="income_container">
                  <div class="sync_detils"></div>
                  <section class="your_income_section">
                    <div class="col-md-6">
                      <div class="info_box date-and-info">
                        <div class="income_title">
                          <h3>{{ singleRetiroMeterDetail.last_modifed_date }}</h3>
                        </div>
                        <div class="income_date d-flex">
                          <p>Update/modify</p>
                          <a @click="updateRetirometer(singleRetiroMeterDetail.member_id)"><v-img max-height="22"
                              max-width="20" :src="syncIcon"></v-img></a>
                        </div>
                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon">
                          <div>
                            <p>Your Desired Monthly Retirement Income from age {{ singleRetiroMeterDetail.age }} onwards</p>
                          </div>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleRetiroMeterDetail.your_desired_retirement_income)" readonly />
                        </div>

                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon">
                          <div>
                            <p>Your Projected Monthly Retirement Income from age {{ singleRetiroMeterDetail.age }}
                              onwards&nbsp;&nbsp;&nbsp;</p>
                          </div>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleRetiroMeterDetail.projected_monthly_retirement_income_per_month)"
                            readonly />
                        </div>
                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon d-block">
                          <div class="d-flex">
                            <div>
                              <p class="mb-1">
                              <p>Your RETIRO METER Score <br><span
                                  class="percent-num">({{ singleRetiroMeterDetail.score }}%)</span></p>
                            </div>
                          </div>
                          <div><span></span></div>
                        </div>
                        <div class="fields">
                          <vue-speedometer :width="150" :height="100" :minValue="0" :needleHeightRatio="0.3"
                            :maxSegmentLabels="4"
                            :customSegmentLabels='[{ text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", fontSize: "19px", }, { text: "", color: "#555", }, { text: "", position: "INSIDE", color: "#555", },]'
                            :segmentColors='["red", "#f6c71e", "lightgreen", "darkgreen"]'
                            :value="(index == 0) ? retiroMeterSpikeVal1 : (index == 1) ? retiroMeterSpikeVal2 : (index == 2) ? retiroMeterSpikeVal3 : (index == 3) ? retiroMeterSpikeVal4 :(index == 4) ? retiroMeterSpikeVal5 : (index == 5) ? retiroMeterSpikeVal6 : retiroMeterSpikeVal7"
                            :currentValueText="singleRetiroMeterDetail.score_text.toString()" valueTextFontSize="9"
                            currentValueColor="black" :segments="4" :ringWidth="15" :needleTransitionDuration="3333"
                            needleTransition="easeElastic" needleColor="#05275e" textColor="#555" />
                        </div>
                      </div>

                    </div>
                    <div class="col-md-6 investments">
                      <div class="info_box date-and-info">
                        <div class="income_title">
                          <h3>{{ singleRetiroMeterDetail.last_modifed_date }}</h3>
                        </div>
                        <div class="income_date d-flex">
                          <p>Update/modify</p>
                          <a @click="updateRetirometer(singleRetiroMeterDetail.member_id)"><v-img max-height="22"
                              max-width="20" :src="syncIcon"></v-img></a>
                        </div>
                      </div>
                      <div class="your_ins_price">
                        <div class="text">
                          <p>Your Required Monthly Retirement Savings (A + B + c)</p>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleRetiroMeterDetail.required_monthly_retirement_savings)" readonly />
                        </div>
                      </div>
                      <div class="your_ins_price">
                        <div class="text">
                          <p>A. Deposit Schemes (PPF, FD, RD, EPF etc)</p>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(parseInt(singleRetiroMeterDetail.required_ppf) + parseInt(singleRetiroMeterDetail.required_epf))"
                            readonly />
                        </div>
                      </div>

                      <div class="your_ins_price">
                        <div class="text">
                          <p>B. National Pension Scheme</p>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleRetiroMeterDetail.required_nps)" readonly />
                        </div>
                      </div>
                      <div class="your_ins_price">
                        <div class="text">
                          <p>C. Equity/Mutual Funds/Deferred Pension/Insurance</p>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleRetiroMeterDetail.required_equity_mf)" readonly />
                        </div>
                      </div>
                    </div>
                  </section>
                  <div class="income_container">
                    <section class="your_income_section">
                      <div class="col-md-12">
                        <div class="terms-box">
                          <p>{{ singleRetiroMeterDetail.message }}</p>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>
      <!-- <p>--------------------------------------End Retirometer-------------------</p>-->




      <!-- <p>--------------------------------------Edumeter-------------------</p>-->
      <v-col xs="12" md="12" class="bottom-cardbox">
        <div class="investomerter-bottom-cardbox">
          <ul>
            <li style="width:100%" v-for="(singleEduMeterDetail, index) in eduMeterDetail" :key="singleEduMeterDetail.id">
              <div class="name-with-logo"><v-img max-width="160" :src="edumeterLogo" :lazy-src="edumeterLogo"> </v-img>
                <h4>{{ singleEduMeterDetail.username }}</h4>
              </div>
              <div class="row">
                <div class="income_container">
                  <div class="sync_detils"></div>
                  <section class="your_income_section">
                    <div class="col-md-6">
                      <div class="info_box date-and-info">
                        <div class="income_title">
                          <h3>{{ singleEduMeterDetail.last_modifed_date }}</h3>
                        </div>
                        <div class="income_date d-flex">
                          <p>Update/modify</p>
                          <a @click="updateEduometer(singleEduMeterDetail.member_id)"><v-img max-height="22"
                              max-width="20" :src="syncIcon"></v-img></a>
                        </div>
                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon">
                          <div>
                            <p>Current Monthly Saving To Meet Educational Expenses</p>
                          </div>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleEduMeterDetail.current_monthly_saving_to_meet_educational_expenses)"
                            readonly />
                        </div>

                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon">
                          <div>
                            <p>Additional Monthly Saving To Meet Educational Expenses</p>
                          </div>
                        </div>
                        <div class="fields">
                          <input type="text" name="" id="" placeholder="₹ 0.00"
                            :value="formatPrice(singleEduMeterDetail.additional_monthly_saving_needed)" readonly />
                        </div>
                      </div>
                      <div class="your_ins_price expenses">
                        <div class="text_icon d-block">
                          <div class="d-flex">
                            <div>
                              <p class="mb-1">
                              <p>Your EDU METER Score <br><span
                                  class="percent-num">({{ singleEduMeterDetail.edumeterScore }}%)</span></p>
                            </div>
                          </div>
                          <div><span></span></div>
                        </div>
                        <div class="fields">
                          <vue-speedometer :width="150" :height="100" :minValue="0" :needleHeightRatio="0.3"
                            :maxSegmentLabels="4"
                            :customSegmentLabels='[{ text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", fontSize: "19px", }, { text: "", color: "#555", }, { text: "", position: "INSIDE", color: "#555", },]'
                            :segmentColors='["red", "#f6c71e", "lightgreen", "darkgreen"]'
                            :value="(index == 0) ? eduMeterSpikeVal1 : (index == 1) ? eduMeterSpikeVal2 : (index == 2) ? eduMeterSpikeVal3 : (index == 3) ? eduMeterSpikeVal4 :(index == 4) ? eduMeterSpikeVal5 : (index == 5) ? eduMeterSpikeVal6 : eduMeterSpikeVal7"
                            :currentValueText="singleEduMeterDetail.score_text.toString()" currentValueColor="black"
                            :segments="4" :ringWidth="15" :needleTransitionDuration="3333" needleTransition="easeElastic"
                            needleColor="#05275e" textColor="#555" valueTextFontSize="9"/>
                        </div>
                      </div>
                      <div class="terms-box">
                        <p>{{ singleEduMeterDetail.message }}</p>

                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>
      <!-- <p>--------------------------------------End Edumeter-------------------</p>-->


      <v-col xs="12" md="12" class="bottom-cardbox">
        <div class="investomerter-bottom-cardbox">
          <ul>
            <li class="riskometer_li" v-for="(credit_score_member_item, key) in credit_score_member_array" :key="key">
              <!--  <div class="riskoMeterLogoClass">
                   <h4>{{riskoMeterItems.username}}</h4>

                  
                </div> -->
              <div class="riskometerUpdate">
                <h4>Credit Experian Score</h4>

                <div class="income_date d-flex">
                  <p>Last Updated : {{ credit_score_member_item.last_modifed_date }}</p>

                </div>
              </div>

              <div class="card-detail">
                <div class="content">
                  <h4>{{ credit_score_member_item.name }}</h4>
                  Experian Score for is <b>{{ credit_score_member_item.credit_score }}/900</b>

                </div>
                <div>
                  <vue-speedometer :width="150" :minValue="0" :needleHeightRatio="0.3" :maxSegmentLabels="4"
                    :customSegmentLabels='[{ text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", }, { text: "", position: "INSIDE", color: "#555", fontSize: "19px", }, { text: "", color: "#555", }, { text: "", position: "INSIDE", color: "#555", },]'
                    :segmentColors='["red", "tomato", "gold", "limegreen", "darkgreen"]'
                    :value="(key == 0) ? credit_experian1 : credit_experian2"
                    :currentValueText="(key == 0) ? credit_experian_txt1.toString() : credit_experian_txt2.toString()"
                    currentValueColor="black" :segments="5" :ringWidth="30" :needleTransitionDuration="3333"
                    needleTransition="easeElastic" needleColor="#05275e" textColor="#555" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>

      <v-col xs="12" md="12">
        <div class="insurance-policy-box">
          <div class="top-head2" style="text-align:center">
            <h3>Let's take a look at what a good score is!</h3>
          </div>
          <div class="Policy-list">
            <ul>
              <li>
                <div class="powereddExp1">
                  <v-img max-height="200" :src="exp" :lazy-src="exp"
                    style="float:left !important; width: 244px;"></v-img>
                </div>
                <div class="powereddExp2">
                  <span>Powered By</span>
                  <v-img max-height="100" :src="experian_logo" :lazy-src="experian_logo"
                    style="float:left !important; width: 244px;"></v-img>
                </div>
              </li>

            </ul>

          </div>
        </div>
      </v-col>

      <v-col xs="12" md="12">
        <div>
          <h2 class="text-center">NOTE</h2>
          <p>Investometer is a financial tool to help you
            understand your real time financial net worth
            and also your contingent net worth.
            It also calculates ratios to help you understand
            your financials in an analytical manner.
            The analysis is targeted to understand the
            financial parameters and think of ways to
            improve it as per your financial goals and risk
            appetite.
            The above ratios are based on the aggregate of
            details of investments &amp; liabilities entered for
            various members.
            You are requested to update your investments
            &amp; liabilities details from time to time for more
            accurate view.
          </p>
        </div>
      </v-col>
      <v-col xs="12" md="12">
        <div>
          <p><b>Net Worth –</b> Your financial net worth is equal to current value of total assets/investments minus the
            outstanding liabilities/loans. The financial net worth ratio is current value of total assets/investments
            divided by total liabilities/loans.
          </p>
          <p>The net worth ratio of say 125% means the market value of your investments is 25% more that your outstanding
            liabilities as on date. Similarly, a net worth ratio of 85% means the market value of your investments is 15%
            lower than your outstanding liabilities. If your net worth ratio is less than 100% it may imply that you have
            more of liabilities than assets.</p>
        </div>
      </v-col>
      <v-col xs="12" md="12">
        <div>
          <p><b>Contingent Net Worth – </b> It is a measure of financial net worth in case of unfortunate demise. Your
            contingent financial net worth is equal to current value of total assets/investments plus all expected pay-in
            from insurance companies on unfortunate death minus the outstanding liabilities/loans.
          </p>
          <p>Ideally your contingent net worth ratio should be significantly more than 100% so that the dependents may
            have adequate financial protection.</p>
        </div>
      </v-col>

      <v-col xs="12" md="12">
        <div>
          <p><b>Interest Ratio – </b> The interest ratio shows how much interest you are paying on various liabilities as
            proportion of your investment.
          </p>
        </div>
      </v-col>

      <v-col xs="12" md="12">
        <div>
          <p><b>Liquid Investment Ratio – </b> Your liquid Investment Ratio shows the proportion of your liquid
            investments such as savings account, short-term fixed deposits and Liquid funds in your total investments.
          </p>
        </div>
      </v-col>

      <v-col xs="12" md="12">
        <div>
          <p><b>Disclaimer – </b>The “Investometer” is generated basis the information provided by you. Nimeya
            Technologies Private Limited is not responsible and neither can be held responsible for the correctness of
            such information. This is also not a guidance or recommendations for your future investments or
            recommendations. The valuation is basis the date the information is updated. You are requested to update the
            investment & liabilities details on regular basis for accurate valuation of your portfolio.
            <br><br>The values and score generated through Riskometer & Protectometer is for illustrative purpose only.
            You are advised to consult your financial advisor before taking any investment decisions.
            <br><br>The insights/content displayer are provided solely by Nimeya and not by Experian Credit Information
            Company of India Private Limited ('Experian'). Experian has not validated any insights/content provided by
            Nimeya. Experian is not liable for any losses or damages (whether direct or indirect) for the content provided
            by Nimeya.
          </p>
        </div>
      </v-col>
    </v-row>
    <div class="text-center ">
      <v-dialog v-model="plan_dialog" width="620">
        <v-card class="secure-modal plan-modalbox">
          <v-img max-height="100" max-width="100" :src="plan_image + icon"></v-img>
          <h2>{{ is_active_plan }}</h2>
          <v-card-title class="text-h5">
            Welcome to Nimeya !
          </v-card-title>
          <v-card-text>
            <ul style="margin-top:10px;">
              <b>Please follow the simple steps to begin your financial wellness journey.</b>
              <div v-if="is_active_plan == 'Silver'" v-for="item in planlist_silver" :key="item.val">
                <li><b>{{ item.val }}</b> {{ item.data }}</li>
              </div>
              <div v-if="is_active_plan == 'Gold'" v-for="item in planlist_gold" :key="item.val">
                <li><b>{{ item.val }}</b> {{ item.data }}</li>
              </div>
              <div v-if="is_active_plan == 'Platinum'" v-for="item in planlist_platinum" :key="item.val">
                <li><b>{{ item.val }}</b> {{ item.data }}</li>
              </div>
            </ul>
            <v-card-actions>
              <v-btn class="blue-btn btn" @click="isMemberalert"> PROCEED
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <modal name="reactivate" class="common-modal-box">
      <div class="modal-inner">
        <div class="popup-image">
          <v-img width="20" height="20" style="float: center;" :src="require('@/assets/images/user-blocked.png')">
          </v-img>
        </div>
        <p>Your account has been temporarily deactivated. To activate your account please renew your subscription by
          paying the subscription fee.</p>
        <p><b> To activate please click below</b></p>
        <div class="buttons">
          <v-btn @click="activateNow" class="restore-btn">Activate Now </v-btn>
          <v-btn @click="activateLater" class="cancel-btn">Activate Later</v-btn>
        </div>
      </div>
    </modal>
    <modal name="mobileVerify" class="common-modal-box">
      <div class="modal-inner">
        <div class="popupImg">
          <h4 class="welcome-text">Verify Mobile OTP</h4>
        </div>
        <span>We have sent OTP on your registered mobile number</span>
        <v-text-field class="" v-model="confirmationCode" :error-messages="confirmationCodeErrors" required
          placeholder="Enter OTP"></v-text-field>
        <div class="buttons">
          <v-btn @click="mobileVerify" class="restore-btn">Verify </v-btn>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";
import JwtService from ".././common/jwt.service";
import { POST_API, GET_API, GET_INVESTOMETER_DETAIL, UPDATE_USER_DETAILS } from "../../store/actions.type";
import { VERIFY_MOBILE_OTP, SEND_MOBILE_OTP, VERIFY_EMAIL_OTP } from "../../store/actions.type";
import { isEmpty } from 'lodash';
import { WhatsApp, Telegram, Email } from 'vue-socialmedia-share';
import ApiService from '@/api/api.service';
import { Auth } from 'aws-amplify';
import VueSpeedometer from "vue-speedometer"
export default {
  components: {
    VueSpeedometer,
    WhatsApp,
    Telegram,
    Email,
  },
  data: () => ({
    spikeVal: 0,
    riskMeter: 'Low',
    riskometeLogo: process.env.VUE_APP_ROOT_ICONS_URL + 'riskometer.svg',
    retirometerLogo: process.env.VUE_APP_ROOT_ICONS_URL + 'retirometer.svg',
    edumeterLogo: process.env.VUE_APP_ROOT_ICONS_URL + 'edumeter.svg',
    currentValueText: '',

    experian_logo: process.env.VUE_APP_ROOT_ICONS_URL + 'experian_logo.png',
    exp: process.env.VUE_APP_ROOT_ICONS_URL + 'exp.png',
    icon: '',
    plan_image: process.env.VUE_APP_ROOT_ICONS_URL,
    is_active_plan: '',
    share_report_url: '',
    planlist_silver: [
      {
        'data': 'Update your profile section.',
        'val': 'Step 1-'
      },
      {
        'data': 'Go to investment, Liabilities & Account tabs to add relevant details.',
        'val': 'Step 2-'
      },
      {
        'data': 'View dashboards and download or share reports.',
        'val': 'Step 3-'
      },
      {
        'data': 'check consolidated view of investment & Liabilities on Investometer tab.',
        'val': 'Step 4-'
      },
      {
        'data': 'Check your financial score.',
        'val': 'Step 5-'
      },
      {
        'data': 'Upload important financial documents on KeepSafe - your Digi Locker.',
        'val': 'Step 6-'
      },
      {
        'data': 'Check notification form time to time for important reminders.',
        'val': 'Step 7-'
      }
    ],
    planlist_gold: [
      {
        'data': 'Update your profile section and add member details (you can add up to 6 members).',
        'val': 'Step 1-'
      },
      {
        'data': 'Go to investment, Liabilities & Account tabs to add relevant details.',
        'val': 'Step 2-'
      },
      {
        'data': 'View dashboards and download or share reports.',
        'val': 'Step 3-'
      },
      {
        'data': 'check consolidated view of investment & Liabilities on Investometer tab.',
        'val': 'Step 4-'
      },
      {
        'data': 'Check your financial score.',
        'val': 'Step 5-'
      },
      {
        'data': 'Upload important financial documents on KeepSafe - your Digi Locker.',
        'val': 'Step 6-'
      },
      {
        'data': 'Check notification form time to time for important reminders.',
        'val': 'Step 7-'
      }
    ],
    planlist_platinum: [
      {
        'data': 'Update your profile section and add member details (you can add up to 15 members).',
        'val': 'Step 1-'
      },
      {
        'data': 'Go to investment, Liabilities & Account tabs to add relevant details.',
        'val': 'Step 2-'
      },
      {
        'data': 'View dashboards and download or share reports.',
        'val': 'Step 3-'
      },
      {
        'data': 'check consolidated view of investment & Liabilities on Investometer tab.',
        'val': 'Step 4-'
      },
      { 'data': 'Check your financial score.', 'val': 'Step 5-' },
      {
        'data': 'Upload important financial documents on KeepSafe - your Digi Locker.',
        'val': 'Step 6-'
      },
      {
        'data': 'Check notification form time to time for important reminders.',
        'val': 'Step 7-'
      }
    ],
    plan_dialog: false,
    redirection: '',
    member_name: '',
    member_items: [],
    currentDate: '',
    investmentTotal: 0,
    liabilityTotal: 0,
    series: [],
    liabilitySeries: [100.10, 200.50],
    email: '',
    mobile_no: '',
    chartOptions: {
      dataLabels: {
        formatter(val) {
          return [val.toFixed() + '%']
        }
      },
      labels: [],
      colors: [],
      chart: {
        type: 'pie',
        edrawOnParentResize: true,
      },
      responsive: [{
        breakpoint: undefined,
        options: {
        }
      }],
      legend: {
        position: 'bottom',
        customLegendItems: ['', '', '', '', '', '', '', '', '', '', '', ''],
        markers: {
          width: 0,
          height: 0,
          strokeWidth: 0,
          strokeColor: '',
          fillColors: undefined,
          radius: 0,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
        },
      }
    },
    liabilityChartOptions: {
      dataLabels: {
        formatter(val) {
          return [val.toFixed() + '%']
        }
      },
      labels: [],
      colors: [],
      chart: {
        type: 'pie',
        edrawOnParentResize: true,
      },
      responsive: [{
        breakpoint: undefined,
        options: {
        }
      }],
      legend: {
        position: 'bottom',
        customLegendItems: ['', '', '', '', '', '', '', '', '', ''],
        markers: {
          width: 0,
          height: 0,
          strokeWidth: 0,
          strokeColor: '',
          fillColors: undefined,
          radius: 0,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
        },
      }
    },
    investmentsData: [],
    liabilityData: [],
    insuranceData: [],
    investometerGraphData: [],
    hasApiResponse: false,
    spike_val1: 0,
    spike_val2: 0,
    spike_val3: 0,
    spike_val4: 0,
    confirmationCode: '',
    confirmationCodeErrors: '',
    credit_score_member_array: [],
    credit_experian1: 300,
    credit_experian2: 300,
    credit_experian3: 300,
    credit_experian4: 300,
    credit_experian5: 300,
    credit_experian6: 300,
    riskoMeterList: [],
    riskoMeterSpikeVal1: 0,
    riskoMeterSpikeVal2: 0,
    riskoMeterSpikeVal3: 0,
    riskoMeterSpikeVal4: 0,
    riskoMeterSpikeVal5: 0,
    riskoMeterSpikeVal6: 0,
    riskoMeterSpikeVal7: 0,


    protectoLifeMeterSpikeVal1: 0,
    protectoLifeMeterSpikeVal2: 0,
    protectoLifeMeterSpikeVal3: 0,
    protectoLifeMeterSpikeVal4: 0,
    protectoLifeMeterSpikeVal5: 0,
    protectoLifeMeterSpikeVal6: 0,
    protectoLifeMeterSpikeVal7: 0,


    protectoHealthMeterSpikeVal1: 0,
    protectoHealthMeterSpikeVal2: 0,
    protectoHealthMeterSpikeVal3: 0,
    protectoHealthMeterSpikeVal4: 0,
    protectoHealthMeterSpikeVal5: 0,
    protectoHealthMeterSpikeVal6: 0,
    protectoHealthMeterSpikeVal7: 0,


    currentLifeInsuranceCover: '30000',
    additionalLifeInsuranceCover: '833712386',
    lifeInsuranceScore: 1,
    lifeInsururanceScoreText: 'Highly Underinsured',

    currentHealthInsuranceCover: '40000',
    additionalHealthInsuranceCover: '260000',
    healthInsuranceScore: 13,
    healthInsururanceScoreText: 'Highly Underinsured',
    spikeValHealth: 150,
    spikeValLife: 170,
    lastModifiedDate: '28 July, 2023',

    syncIcon: process.env.VUE_APP_ROOT_ICONS_URL + 'sync.svg',
    protectometerLogo: process.env.VUE_APP_ROOT_ICONS_URL + 'protectometer.svg',
    protectoMeterDetail: [],
    credit_experian_txt1: 0,
    credit_experian_txt2: 0,
    credit_experian_txt3: 0,
    credit_experian_txt4: 0,
    credit_experian_txt5: 0,
    credit_experian_txt6: 0,

    retiroMeterDetail: [],
    retiroMeterSpikeVal1: 0,
    retiroMeterSpikeVal2: 0,
    retiroMeterSpikeVal3: 0,
    retiroMeterSpikeVal4: 0,
    retiroMeterSpikeVal5: 0,
    retiroMeterSpikeVal6: 0,
    retiroMeterSpikeVal7: 0,

    eduMeterDetail: [],
    eduMeterSpikeVal1: 0,
    eduMeterSpikeVal2: 0,
    eduMeterSpikeVal3: 0,
    eduMeterSpikeVal4: 0,
    eduMeterSpikeVal5: 0,
    eduMeterSpikeVal6: 0,
    eduMeterSpikeVal7: 0,


  }),

  mounted() {
    //this.refreshDashboard('')
    Fire.$on("updateAllDepositData", () => {
      this.shareLink();
    });

    if (!isEmpty(this.$store.getters.getInvestometerDetail)) {
      this.shareLink();
    }
  },

  created() {
    this.$loading(true);

    let mainName = '';


    Auth.currentAuthenticatedUser({
      bypassCache: false
    }).then(user => {


      this.user_name = user.attributes["custom:name"];








      this.member_name = this.$route.params.investometer_member_id

      let user_name = this.user_name;
      let member_id = this.$store.getters.getUserDetails.member_id;
      this.$store.dispatch(GET_INVESTOMETER_DETAIL, {
        data: {
          aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
          user_name: user_name,
          member_id: localStorage.getItem('investometer_member_id'),
        },
        api: 'get-investometer-list',
      }).then(() => {
        let response = this.$store.getters.getInvestometerDetail;
        if (response.exp_mem_expiry_members_str != '') {
          swal.fire({
            icon: 'info',

            text: 'The consent to update liability data using Experian Credit Bureau has expired for the ' + response.exp_mem_expiry_members_str + '. Please  update the same in Liability Module.',
            showCancelButton: true,
            confirmButtonColor: `#051d42`,
            cancelButtonText: `Cancel`,
            confirmButtonText: `Update Now`,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.isConfirmed == true) {
              this.$router.push({ name: "liabilities-dashboard", params: {} }).catch(() => { });
            }
            else {

            }
          })
        }
        this.credit_score_member_array = response.data.credit_score_member_array;
        this.riskoMeterList = response.riskMeterDetail;
        this.protectoMeterDetail = response.protectoMeterDetail;
        this.retiroMeterDetail = response.retirometerMeterDetail;
        this.eduMeterDetail = response.eduMeterDetail;


        setTimeout(() => {
          let score = 100;
          let ci = 1;
          this.credit_score_member_array.forEach(ceElementData => {
            if (ceElementData.credit_score >= 300 && ceElementData.credit_score < 500) {
              score = 100;

            }
            else if (ceElementData.credit_score >= 500 && ceElementData.credit_score < 650) {
              score = 300;
            }
            else if (ceElementData.credit_score >= 650 && ceElementData.credit_score < 750) {
              score = 500;
            }
            else if (ceElementData.credit_score >= 750 && ceElementData.credit_score < 850) {
              score = 700;
            }
            else if (ceElementData.credit_score > 850) {
              score = 900;
            }
            if (ci == 1) {
              this.credit_experian1 = parseInt(score)
              this.credit_experian_txt1 = ceElementData.credit_score

            }
            else if (ci == 2) {
              this.credit_experian2 = parseInt(score)
              this.credit_experian_txt2 = ceElementData.credit_score
            }
            else if (ci == 3) {
              this.credit_experian3 = parseInt(score)
              this.credit_experian_txt3 = ceElementData.credit_score

            }
            else if (ci == 4) {
              this.credit_experian4 = parseInt(score)
              this.credit_experian_txt4 = ceElementData.credit_score
            }
            else if (ci == 5) {
              this.credit_experian5 = parseInt(score)
              this.credit_experian_txt5 = ceElementData.credit_score

            }
            else if (ci == 6) {
              this.credit_experian6 = parseInt(score)
              this.credit_experian_txt6 = ceElementData.credit_score
            }
            ci++;
          });

          let riskometeri = 1;
          this.riskoMeterList.forEach(riskoMeterItems => {
            if (riskometeri == 1) {
              this.riskoMeterSpikeVal1 = riskoMeterItems.spike_value
            }
            else if (riskometeri == 2) {

              this.riskoMeterSpikeVal2 = riskoMeterItems.spike_value
            }
            else if (riskometeri == 3) {
              this.riskoMeterSpikeVal3 = riskoMeterItems.spike_value
            }
            else if (riskometeri == 4) {
              this.riskoMeterSpikeVal4 = riskoMeterItems.spike_value
            }
            else if (riskometeri == 5) {
              this.riskoMeterSpikeVal5 = riskoMeterItems.spike_value
            }
            else if (riskometeri == 6) {
              this.riskoMeterSpikeVal6 = riskoMeterItems.spike_value
            }
            else {
              this.riskoMeterSpikeVal7 = riskoMeterItems.spike_value

            }
            riskometeri++;
          });


          let protectoMeterLifei = 1;
          this.protectoMeterDetail.forEach(protectoMeterLifeItems => {
            if (protectoMeterLifei == 1) {
              this.protectoLifeMeterSpikeVal1 = protectoMeterLifeItems.spikeValLife
            }
            else if (protectoMeterLifei == 2) {

              this.protectoLifeMeterSpikeVal2 = protectoMeterLifeItems.spikeValLife
            }
            else if (protectoMeterLifei == 3) {
              this.protectoLifeMeterSpikeVal3 = protectoMeterLifeItems.spikeValLife
            }
            else if (protectoMeterLifei == 4) {
              this.protectoLifeMeterSpikeVal4 = protectoMeterLifeItems.spikeValLife
            }
            else if (protectoMeterLifei == 5) {
              this.protectoLifeMeterSpikeVal5 = protectoMeterLifeItems.spikeValLife
            }
            else if (protectoMeterLifei == 6) {
              this.protectoLifeMeterSpikeVal6 = protectoMeterLifeItems.spikeValLife
            }
            else {
              this.protectoLifeMeterSpikeVal7 = protectoMeterLifeItems.spikeValLife

            }
            protectoMeterLifei++;
          });


          let retiroMeteri = 1;
          this.retiroMeterDetail.forEach(retiroMeterItems => {
            if (retiroMeteri == 1) {
              this.retiroMeterSpikeVal1 = retiroMeterItems.spikeValue
            }
            else if (retiroMeteri == 2) {

              this.retiroMeterSpikeVal2 = retiroMeterItems.spikeValue
            }
            else if (retiroMeteri == 3) {
              this.retiroMeterSpikeVal3 = retiroMeterItems.spikeValue
            }
            else if (retiroMeteri == 4) {
              this.retiroMeterSpikeVal4 = retiroMeterItems.spikeValue
            }
            else if (retiroMeteri == 5) {
              this.retiroMeterSpikeVal5 = retiroMeterItems.spikeValue
            }
            else if (retiroMeteri == 6) {
              this.retiroMeterSpikeVal6 = retirMeterItems.spikeValue
            }
            else {
              this.retiroMeterSpikeVal7 = retirMeterItems.spikeValue

            }
            retiroMeteri++;
          });



          let protectoMeterHealthi = 1;
          this.protectoMeterDetail.forEach(protectoMeterHealthItems => {
            if (protectoMeterHealthi == 1) {
              this.protectoHealthMeterSpikeVal1 = protectoMeterHealthItems.spikeValHealth
            }
            else if (protectoMeterHealthi == 2) {

              this.protectoHealthMeterSpikeVal2 = protectoMeterHealthItems.spikeValHealth
            }
            else if (protectoMeterHealthi == 3) {
              this.protectoHealthMeterSpikeVal3 = protectoMeterHealthItems.spikeValHealth
            }
            else if (protectoMeterHealthi == 4) {
              this.protectoHealthMeterSpikeVal4 = protectoMeterHealthItems.spikeValHealth
            }
            else if (protectoMeterHealthi == 5) {
              this.protectoHealthMeterSpikeVal5 = protectoMeterHealthItems.spikeValHealth
            }
            else if (protectoMeterHealthi == 6) {
              this.protectoHealthMeterSpikeVal6 = protectoMeterHealthItems.spikeValHealth
            }
            else {
              this.protectoHealthMeterSpikeVal7 = protectoMeterHealthItems.spikeValHealth

            }
            protectoMeterHealthi++;
          });

          let eduMeteri = 1;
          this.eduMeterDetail.forEach(eduMeterItems => {
            if (eduMeteri == 1) {
              this.eduMeterSpikeVal1 = eduMeterItems.spikeValue
            }
            else if (eduMeteri == 2) {

              this.eduMeterSpikeVal2 = eduMeterItems.spikeValue
            }
            else if (eduMeteri == 3) {
              eduetiroMeterSpikeVal3 = eduMeterItems.spikeValue
            }
            else if (eduMeteri == 4) {
              this.eduMeterSpikeVal4 = eduMeterItems.spikeValue
            }
            else if (eduMeteri == 5) {
              this.eduMeterSpikeVal5 = eduMeterItems.spikeValue
            }
            else if (eduMeteri == 6) {
              this.eduMeterSpikeVal6 = eduMeterItems.spikeValue
            }
            else {
              this.eduMeterSpikeVal7 = eduMeterItems.spikeValue

            }
            eduMeteri++;
          });
        }, 1000)

        this.is_allow_access_app = response.is_allow_access_app;
        if (response.data.deactivated == 1) {
          localStorage.setItem("deactivated", btoa(response.data.deactivated == 1));
        }
        else {
          localStorage.setItem("deactivated", btoa(response.data.deactivated == 0));
        }

        this.currentDate = response.curr_year;
        if (response.data.deactivated != 0 && response.data.curr_plan_date > response.data.plan_expire_date) {
          this.$modal.show("reactivate");
        }
        if (response.app_status == 'proceed_to_payment') {
          localStorage.setItem("freeTrialOver", 0);
          if (response.plan_status == 'PAID') {
            this.$router.push({ name: "pricingPlan", params: { plan_id: response.plan_id } }).catch(() => { });
          }
          else if (response.data.deactivated == 0) {
            localStorage.setItem("freeTrialOver", 1);
            this.isFreeTrailOver(response.plan_id)
          }
        }
        else {
          localStorage.setItem("isFreeTrail", response.is_free_trail);
          localStorage.setItem("deductionPercentage", response.deduction_percentage);
          if (response.is_show_dob == null || response.is_show_dob == 'no') {
            let check_dob_key = localStorage.getItem("check_dob_key");
            if (check_dob_key == null) {
              localStorage.setItem("check_dob_key", "1");
              this.isCheckedDob();
            }
          }
          else if (response.is_free_trail == 'yes') {
            this.isFreeTrail(response.free_trail_day_left);
          }
          if (response.app_status == 'grace_period') {
            this.isGracePeriod(response.plan_id, response.grace_period_text)
            localStorage.setItem("isGracePeriod", 1);
            localStorage.setItem("showReedemedPointBox", 1);

          }
          else {
            localStorage.setItem("isGracePeriod", 0);
            localStorage.setItem("showReedemedPointBox", 0);

          }
          if (response.is_show_message == true) {
            this.is_active_plan = response.plan_type;
            if (response.plan_type == 'Silver') {
              this.icon = 'sliver-icon.png';
            }
            else if (response.plan_type == 'Gold') {
              this.icon = 'gold-icon.png';
            }
            else {
              this.icon = 'platinum-icon.png';
            }
            this.plan_dialog = true;
          }
        }

        response.member_list.forEach(elementData => {
          this.member_items.push({ 'id': elementData.id, 'name': elementData.name })
        });

        this.investmentsData = response.data.total_investment.balances;
        this.liabilityData = response.data.total_liability.balances;
        this.insuranceData = response.data.insurance_details;
        this.investmentTotal = response.data.total_investment.total;
        this.liabilityTotal = response.data.total_liability.total;
        this.investometerGraphData = response.data.investometer_graph_detail;

        setTimeout(() => {
          this.spike_val1 = response.data.investometer_graph_detail[0]['spike_val']
          this.spike_val2 = response.data.investometer_graph_detail[1]['spike_val']
          this.spike_val3 = response.data.investometer_graph_detail[2]['spike_val']
          this.spike_val4 = response.data.investometer_graph_detail[3]['spike_val']
        }, 3000);


        this.series = this.series.length == 0 ? this.series : [];
        this.investmentsData.forEach(balance_detail => {
          this.series.push(parseFloat(balance_detail.amount));
          this.chartOptions.labels.push(balance_detail.name)
          this.chartOptions.colors.push(balance_detail.web_color)
        });
        this.liabilitySeries = this.liabilitySeries.length == 0 ? this.liabilitySeries : [];
        this.liabilityData.forEach(balance_detail => {
          this.liabilityChartOptions.labels.push(balance_detail.name)
          this.liabilityChartOptions.colors.push(balance_detail.web_color)
          this.liabilitySeries.push(balance_detail.amount);
        });
        this.hasApiResponse = true
        this.$loading(false);
        localStorage.setItem('investometer_member_id', '')
      })
        .catch(function (error) {
        });
      if (this.CategoryListData == undefined) {
        this.$store.dispatch(POST_API, {
          data: {
            aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
            category_id: 2,
          },
          api: 'subcategory-listing',
          action: "category_data"
        })
          .then((res) => {
            this.updateCategoryListData('commitCategoryListData', res.data)
          });
      }

    })
  },
  methods: {
    activateLater() {
      this.$router.push("/");
      this.$modal.hide("reactivate");
    },
    activateNow() {
      this.$modal.show("mobileVerify");
      this.$modal.hide("reactivate");
      this.$store.dispatch(VERIFY_EMAIL_OTP, {
        data: {
          mobile_no: this.$store.getters.getUserDetails.mobile_no,
          aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
        },
        api: 'send-otp',
      })
        .then(() => {
          if (this.$store.getters.getVerifyEmailOtp.data.status == 'error') {
            console.log(this.$store.getters.getVerifyEmailOtp)
            return [];
          } else {
            Toast.fire({
              title: "OTP sent successfully",
              icon: 'success',
            })
          }
        })
        .catch((error) => {
        });
    },
    mobileVerify() {
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("otp", this.confirmationCode);
      formdata.append(
        "mobile_no",
        this.$store.getters.getUserDetails.mobile_no
      );
      axios
        .post(
          process.env.VUE_APP_ROOT_API + "verify-otp",
          formdata,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data.status == "error") {
            this.otpError = response.data.message;
          }
          else {
            axios.post(process.env.VUE_APP_ROOT_API + 'reactivate-account',
              formdata, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*'
              }
            }
            ).then((response) => {
              if (response.data.status == 'success') {
                this.$router.push({ name: "pricingPlan" }).catch(() => { });
                this.$modal.hide("mobileVerify");
              }
            }).catch(() => {
              this.$loading(false);
            });
          }
        });

    },
    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {});
      return formatter.format(value);
    },
    isFreeTrailOver(plan_id) {
      swal.fire({
        icon: 'info',
        text: 'Your Trial Period has ended. To continue your financial wellness journey please confirm your subscription and make necessary payment.',
        showCancelButton: true,
        confirmButtonColor: `#051d42`,
        cancelButtonText: `Pay Later`,
        confirmButtonText: `Pay Now`,
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "pricingPlan", params: { plan_id: plan_id } }).catch(() => { });
          }
          else {
            if (this.is_allow_access_app == false)
              this.$router.push({ name: "Login", params: { plan_id: plan_id } }).catch(() => { });
          }
        })
    },
    isGracePeriod(plan_id, grace_period_text) {
      swal.fire({
        icon: "info",
        text: grace_period_text,
        showCancelButton: true,
        confirmButtonColor: `#051d42`,
        cancelButtonText: `Pay Later`,
        confirmButtonText: `Pay Now`,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push({ name: "pricingPlan", params: { plan_id: plan_id } }).catch(() => { });
        }
        else {
          this.$router.push({ name: 'Investometer' }).catch(() => { });
        }
      })
    },
    isMemberalert() {
      this.plan_dialog = false;
      if (this.is_active_plan == 'Silver') {
        this.$router.push({ name: "Investment" }).catch(() => { });
      }
      else {
        this.$router.push({ name: "dashboard" }).catch(() => { });
      }
    },
    isFreeTrail(days) {
      swal.fire({
        icon: "info",
        text: 'Your Trial Period will end in ' + days + ' days. To continue your financial wellness journey please confirm your subscription and make necessary payment on due date.',
        showCancelButton: false,
        confirmButtonColor: `#051d42`,
        confirmButtonText: `OK`,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // this.$router.push({ name: "EditProfile"}).catch(()=>{});
        }
      })
    },
    isCheckedDob() {
      swal.fire({
        icon: "info",
        text: 'To further proceed please select your date of birth in the edit profile.',
        showCancelButton: false,
        confirmButtonColor: `#051d42`,
        confirmButtonText: `Proceed`,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push({ name: "EditProfile", params: { isback: true } }).catch(() => { });
        }
      })
    },
    refreshDashboard(event) {
      this.$loading(true);

      let user_name = this.user_name;

      this.$store.dispatch(GET_INVESTOMETER_DETAIL, {
        data: {
          aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
          user_name: user_name,
          member_id: event,
        },
        api: 'get-investometer-list',
      }).then(() => {
        let response = this.$store.getters.getInvestometerDetail;
        this.credit_score_member_array = response.data.credit_score_member_array



        setTimeout(() => {
          let ci = 1;
          this.credit_score_member_array.forEach(ceElementData => {
            if (ci == 1) {
              this.credit_experian1 = parseInt(ceElementData.credit_score)

            }
            else if (ci == 2) {
              this.credit_experian2 = parseInt(ceElementData.credit_score)

            }
            else if (ci == 3) {
              this.credit_experian3 = parseInt(ceElementData.credit_score)

            }
            else if (ci == 4) {
              this.credit_experian4 = parseInt(ceElementData.credit_score)

            }
            else if (ci == 5) {
              this.credit_experian5 = parseInt(ceElementData.credit_score)

            }
            else if (ci == 6) {
              this.credit_experian6 = parseInt(ceElementData.credit_score)
            }

            ci++;
          });
        }, 1000)

        this.is_allow_access_app = response.is_allow_access_app;
        if (response.data.deactivated == 1) {
          localStorage.setItem("deactivated", btoa(response.data.deactivated == 1));
        }
        else {
          localStorage.setItem("deactivated", btoa(response.data.deactivated == 0));
        }

        this.currentDate = response.curr_year;
        if (response.data.deactivated != 0 && response.data.curr_plan_date > response.data.plan_expire_date) {
          this.$modal.show("reactivate");
        }
        if (response.app_status == 'proceed_to_payment') {
          localStorage.setItem("freeTrialOver", 0);
          if (response.plan_status == 'PAID') {
            this.$router.push({ name: "pricingPlan", params: { plan_id: response.plan_id } }).catch(() => { });
          }
          else if (response.data.deactivated == 0) {
            localStorage.setItem("freeTrialOver", 1);
            this.isFreeTrailOver(response.plan_id)
          }
        }
        else {
          localStorage.setItem("isFreeTrail", response.is_free_trail);
          localStorage.setItem("deductionPercentage", response.deduction_percentage);
          if (response.is_show_dob == null || response.is_show_dob == 'no') {
            let check_dob_key = localStorage.getItem("check_dob_key");
            if (check_dob_key == null) {
              localStorage.setItem("check_dob_key", "1");
              this.isCheckedDob();
            }
          }
          else if (response.is_free_trail == 'yes') {
            this.isFreeTrail(response.free_trail_day_left);
          }
          if (response.app_status == 'grace_period') {
            this.isGracePeriod(response.plan_id, response.grace_period_text)
            localStorage.setItem("isGracePeriod", 1);
          }
          else {
            localStorage.setItem("isGracePeriod", 0);
          }
          if (response.is_show_message == true) {
            this.is_active_plan = response.plan_type;
            if (response.plan_type == 'Silver') {
              this.icon = 'sliver-icon.png';
            }
            else if (response.plan_type == 'Gold') {
              this.icon = 'gold-icon.png';
            }
            else {
              this.icon = 'platinum-icon.png';
            }
            this.plan_dialog = true;
          }
        }

        response.member_list.forEach(elementData => {
          this.member_items.push({ 'id': elementData.id, 'name': elementData.name })
        });

        this.investmentsData = response.data.total_investment.balances;
        this.liabilityData = response.data.total_liability.balances;
        this.insuranceData = response.data.insurance_details;
        this.investmentTotal = response.data.total_investment.total;
        this.liabilityTotal = response.data.total_liability.total;
        this.investometerGraphData = response.data.investometer_graph_detail;

        setTimeout(() => {
          this.spike_val1 = response.data.investometer_graph_detail[0]['spike_val']
          this.spike_val2 = response.data.investometer_graph_detail[1]['spike_val']
          this.spike_val3 = response.data.investometer_graph_detail[2]['spike_val']
          this.spike_val4 = response.data.investometer_graph_detail[3]['spike_val']
        }, 3000);


        this.series = this.series.length == 0 ? this.series : [];
        this.investmentsData.forEach(balance_detail => {
          this.series.push(parseFloat(balance_detail.amount));
          this.chartOptions.labels.push(balance_detail.name)
          this.chartOptions.colors.push(balance_detail.web_color)
        });
        this.liabilitySeries = this.liabilitySeries.length == 0 ? this.liabilitySeries : [];
        this.liabilityData.forEach(balance_detail => {
          this.liabilityChartOptions.labels.push(balance_detail.name)
          this.liabilityChartOptions.colors.push(balance_detail.web_color)
          this.liabilitySeries.push(balance_detail.amount);
        });
        this.hasApiResponse = true
        this.$loading(false);
        localStorage.setItem('investometer_member_id', '')
      })
        .catch(function (error) {
        });
      if (this.CategoryListData == undefined) {
        this.$store.dispatch(POST_API, {
          data: {
            aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
            category_id: 2,
          },
          api: 'subcategory-listing',
          action: "category_data"
        })
          .then((res) => {
            this.updateCategoryListData('commitCategoryListData', res.data)
          });
      }
    },

    downloadReport() {
      window.open(this.$store.getters.getInvestometerDetail.pdf_url, '_blank');

    },
    shareLink() {
      this.share_report_url = this.$store.getters.getInvestometerDetail.pdf_url;
      return this.share_report_url;
    },
    redirectDashboard(name) {
      console.log(name)
      if (name == 'Bullions') {
        this.$router.push({ name: "bullions-dashboard" }).catch(() => { });
      }
      else if (name == 'Commodities') {
        this.$router.push({ name: "commodities-dashboard" }).catch(() => { });
      }
      else if (name == 'Mutual Funds') {
        this.$router.push({ name: "mutual-dashboard" }).catch(() => { });
      }
      else if (name == 'Real Estate') {
        this.$router.push({ name: "real-state-dashboard" }).catch(() => { });
      }
      else if (name == 'Savings Accounts') {
        this.$router.push({ name: "deposit-dashboard", params: { tab: 'tab-1' } }).catch(() => { });
      }
      else if (name == 'Life Insurance') {
        this.$router.push({ name: "insurance-dashboard" }).catch(() => { });
      }
      else if (name == 'Equities & Bonds') {
        this.$router.push({ name: "equities-dashboard" }).catch(() => { });
      }
      else if (name == 'Fixed Deposits') {
        this.$router.push({ name: "deposit-dashboard", params: { tab: 'tab-2' } }).catch(() => { });
      }
      else if (name == 'Private Investment') {
        this.$router.push({ name: "private-dashboard" }).catch(() => { });
      }
      else if (name == 'Recurring Deposits') {
        this.$router.push({ name: "deposit-dashboard", params: { tab: 'tab-3' } }).catch(() => { });
      }
      else if (name == 'Retirement') {
        this.$router.push({ name: "retirement-dashboard" }).catch(() => { });
      }
      else if (name == 'Sukanya Samriddhi') {
        this.$router.push({ name: "deposit-dashboard", params: { tab: 'tab-4' } }).catch(() => { });
      }
      else {
        this.$router.push({ name: "Investometer" }).catch(() => { });
        console.log("Route not found.")
      }
    },
    redirectLiabilityDashboard(name) {
      if (name == 'Home Loan') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-1' } }).catch(() => { });
      }
      else if (name == 'Policy Loan') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-5' } }).catch(() => { });
      }
      else if (name == 'Consumer Loan') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-7' } }).catch(() => { });
      }
      else if (name == 'Student Loan') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-3' } }).catch(() => { });
      }
      else if (name == 'Two Wheeler Loan') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-9' } }).catch(() => { });
      }
      else if (name == 'Car Loan') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-4' } }).catch(() => { });
      }
      else if (name == 'Loan Against Property') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-8' } }).catch(() => { });
      }
      else if (name == 'Personal Loan') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-2' } }).catch(() => { });
      }
      else if (name == 'Overdraft') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-6' } }).catch(() => { });
      }
      else if (name == 'Credit Card') {
        this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-10' } }).catch(() => { });
      }
      else {
        this.$router.push({ name: "Investometer" }).catch(() => { });
        console.log("Route not found.")
      }
    },

    getMemberID() {
      return localStorage.getItem('investometer_member_id')

    },

    checkTerm() {
      this.$router.push({ name: "FinStat", params: {} }).catch(() => { });
    },

    updateRetirometer(id) {
      if (id == 0) {
        id = '0';
      }
      this.$router.push({
        name: 'RetiroMeterForm',
        params: { id: id, props: true },
      });
    },

    updateEduometer(id) {
      if (id == 0) {
        id = '0';
      }
      this.$router.push({
        name: 'EduMeterForm',
        params: { id: id, props: true },
      });
    },

    updateProtectometer(id) {
      if (id == 0) {
        id = '0';
      }
      this.$router.push({
        name: 'ProtectoMeterForm',
        params: { id: id, props: true },
      });
    },

    moveToRikometer(id) {
      this.$router.push({
        name: 'ValueAddedServices',
        params: { id: id, props: true },
      });
    }
  }
};
</script>
<style scoped>
.investomerter-dashboad .insurance-policy-box .top-head2 {
  /* display: flex; */
  justify-content: space-between;
  align-items: center;

  margin-bottom: 20px;
}


.riskmeter_main .v-card__title.text-h5 {
  border: 0;
  padding: 0;
}

.riskmeter_main {
  padding-top: 0;
}

.speedometer {
  height: auto !important;
  width: auto !important;
}

.meter_text_box {
  display: flex;
  align-items: center;
  padding: 30px 22px;
}

.riskMeter_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}

.secure-modal.proceed-modal.csv-file-modal.riskmeter_main.v-card.v-sheet.theme--light {
  border: 1px solid #F19700;
}

.riskmeter_main .row {
  flex-wrap: nowrap;
  margin: 0px;
}

.riskmeter_main .v-card__text {
  padding: 0;
}

.riskmeter_main .row .col {
  border-radius: 0;
  box-shadow: none;
  background: #1A407D;
  color: white;
}

.riskmeter_main .meter_wrapper .meter_text_box .riskmeter-speedometer-img,
.riskmeter_main .meter_wrapper .meter_text_box .riskemeter_text_content {
  width: 48%;
  max-width: 100%;
}

.riskmeter_main .meter_wrapper .meter_text_box .riskmeter-speedometer-img {
  display: flex;
  justify-content: center;
}

.meter_text_box {
  justify-content: space-between;
}

.riskmeter_main .meter_wrapper .meter_text_box .riskmeter-speedometer-img[data-v-0fd252af] {
  border-right: 1px solid #F19700;
}

.riskmeter_main.v-card.v-sheet.theme--light {
  border: 1px solid #F19700;
  overflow: hidden;
  margin-bottom: 20px;
}

.investomerter-dashboad .investomerter-bottom-cardbox ul li .card-detail svg.speedometer text.current-value {
  display: block !important;
}

.riskoMeterLogoClass {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.investomerter-dashboad .insurance-policy-box .Policy-list ul li {
  flex-direction: column;
}

.powereddExp1 {
  display: flex;
}

.powereddExp2 {
  display: flex;
  justify-content: end;
  align-items: center;
}

.powereddExp2 .v-image.v-responsive.theme--light {
  max-width: 200px;
  width: 100%;
}

.powereddExp2 span {
  padding-top: 15px;
}

.income_container {
  width: 100%;
}

.income_container input[type="text"] {
  width: 111px;
  height: 49px;
  border: 1px solid #DDDDDD;
  border-radius: 6px;
  text-align: center;

}

.income_container .col-md-6.expenses {
  padding-right: 30px;
}

.income_container .col-md-6 {
  padding-right: 30px;
  padding-left: 30px;
}

.income_container .proceed_btn button {
  border: none;
  padding: 13px 50px;
  font-size: 15px;
}

.income_container .proceed_btn .btn1 {
  border: 1px solid #051D42;
  border-radius: 6px;
  background-color: transparent;
}

.income_container .proceed_btn .btn_proceed {
  background-color: #051D42;
  color: white;
  margin-left: 20px;
}

.proceed_btn .btn_cancel:hover {
  background-color: #051D42;
  color: white;
  transition: .3s ease all;
}

.proceed_btn .btn_proceed:hover {
  background-color: transparent;
  color: black;
  transition: .3s ease all;
}

.income_container .sync_detils span::after {
  content: '';
  height: 20px;
  width: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  margin-left: 5px;
  position: absolute;
  top: 3px;
}

section.your_income_section {
  display: flex;
  width: 100%
}

.add-new-memberbox .row.buttonbox {
  margin-bottom: 25px !important;
  margin-top: 50px !important;
}

.text_icon {
  display: flex;
  justify-content: space-between;
}

.icon_tick {
  margin-left: 8px;
  margin-top: 2px;
}

.info_box.date-and-info {
  font-size: 14px;
}

.info_box.date-and-info h3 {
  font-size: 14px !important;
  color: #818181 !important;
  font-weight: 500;
}

.info_box.date-and-info p {
  margin: 0;
  color: #818181 !important;
  font-weight: 400;
  margin-right: 5px;
}

span.percent-num {
  font-size: 20px !important;
  color: #1A407D !important;
}

.terms-box {
  background: #F3F3F3;
  padding: 15px 20px;
  margin-top: 20px;
}

.sync_detils.main-sync-heading {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.sync_detils.main-sync-heading span {
  border: none !important;
  margin-right: 5px;
}

.heigth-150 svg.speedometer {
  height: 150px !important;
}

.your_ins_price,
.your_ins_price.expenses {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
}


.col-md-6.investments {
  border-left: 1px solid lightgrey;
}

.income_container .info_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.name-with-logo {
  padding: 0 15px;
}

.name-with-logo h4 {
  margin: 13px 0;
  font-size: 22px;
}

.riskometerUpdate {
  display: flex;
  justify-content: space-between;
}

.current-value {
  font-size: 15px !important;
}
</style>